<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      :footer="false"
      size="normal"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText">
    <template #header>
      <span>导入分摊费用</span>
    </template>
    <template #content>
      <el-form
          ref="form"
          v-model="form"
      >
        <el-form-item
            label="导入分摊的月份"
            prop="feeMonth"
        >
          <gj-date-picker
              v-model="form.feeMonth"
              type="month"
              :clearable="false"
              width="120px"
          ></gj-date-picker>
        </el-form-item>
      </el-form>

      <gj-upload
          text="导入分摊费用"
          class="upload-btn"
          :template-url="`/finance/feeManualShare/downLoadFeeManualShareTemplate?feeShareMonth=${format(form.feeMonth,'yyyy-MM')}`"
          :accept-type="[FileTypeEnum.XLSX, FileTypeEnum.XLS, FileTypeEnum]"
          container-type="category"
          @uploadAfter="uploadAfter">
        <template #tip>
<!--          /finance/financialFeeItemUseDetail/downloadMarketTemplate-->
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '模板中的表头不可更改，不可删除',
            '同一店铺/国家下的同一个费用项的金额总和，需与对应站点维度的费用金额相等；否则会导入失败',
            '导入已分摊的费用项，则以导入分摊的费用金额为准',
            '文件大小不可超过20M',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, uploadMixin} from "@/minxins";
import {importMarketExcel, importMskuExcel,feeManualShareImport} from "@/api/finance"
import {ExpensesTypeEnum} from "@/views/modules/finance/finance-profit-report/common/enum.js";
import {format,subDays} from "date-fns";
import {FileTypeEnum} from "@/components/upload/enum";

export default {
  name: "import-average-expenses",
  mixins: [modalMixIn, uploadMixin],
  props:{
    tabsActive:{
      type: String,
    }
  },
  data(){
    return {
      form:{
        feeMonth: new Date(),
      },
      format:format,
      ExpensesTypeEnum: ExpensesTypeEnum,
      disabled: false,
      FileTypeEnum:FileTypeEnum
    }
  },
  methods:{
    destroy() {
      this.$gjModal.$gjDestroy();
    },
    uploadAfter(attId, data, uploadCb) {
      const { feeMonth } = this.form;
      this.importHandleLoading = true;
      feeManualShareImport(attId, format(feeMonth,'yyyy-MM'))
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
    },
    // uploadAfter(attId) {
    //   const { feeMonth } = this.form;
    //   this.importHandleLoading = true;
    //   importMarketExcel(attId, format(feeMonth,'yyyy-MM'))
    //       .then((res) => {
    //         this.$gjImportHandle(res);
    //       })
    //       .complete(() => this.importHandleLoading = false);
    // }
  }
}
</script>

<style scoped>
.upload-btn {
  margin: 5px 0 15px;
}
</style>